export const primary = 'var(--tra-color-action-accent-400)';
export const primaryMedium = 'var(--tra-color-action-accent-500)';
export const primaryDark = 'var(--tra-color-action-accent-500)';
export const primaryBlack = 'var(--tra-color-neutral-700)';
export const secondary = 'var(--tra-color-neutral-500)';
export const lighterGrey = 'var(--tra-color-warm-100)';
export const textColor = 'var(--tra-color-neutral-600)';
export const darkModeBackground = 'var(--tra-color-neutral-600)';
export const backgroundGrey = 'var(--tra-color-warm-100)';
export const errorRed = 'var(--tra-color-red-400)';
export const brandPrimaryADASoot = 'var(--tra-color-action-accent-300)';
// the focus color contrast has to be 3:1 to be WCAG 2 compliant
export const focusColor = 'var(--tra-color-action-accent-400)';

export const neutral = Object.freeze({
  0: 'var(--tra-color-neutral-100)',
  50: 'var(--tra-color-warm-100)',
  100: 'var(--tra-color-warm-100)',
  200: 'var(--tra-color-warm-300)',
  300: 'var(--tra-color-neutral-200)',
  400: 'var(--tra-color-neutral-300)',
  500: 'var(--tra-color-neutral-300)',
  550: 'var(--tra-color-warm-500)',
  600: 'var(--tra-color-neutral-500)',
  700: 'var(--tra-color-neutral-500)',
  800: 'var(--tra-color-neutral-600)',
  900: 'var(--tra-color-neutral-700)',
});

export const warm = Object.freeze({
  50: 'var(--tra-color-warm-100)',
  100: 'var(--tra-color-warm-100)',
  200: 'var(--tra-color-warm-200)',
  300: 'var(--tra-color-warm-300)',
  400: 'var(--tra-color-warm-400)',
  500: 'var(--tra-color-warm-400)',
  600: 'var(--tra-color-neutral-300)',
  700: 'var(--tra-color-warm-500)',
  800: 'var(--tra-color-warm-500)',
  900: 'var(--tra-color-warm-500)',
});

export const headerFontFamily = "'Knockout', sans-serif";
export const bannerFontFamily = "'Knockout-Banner', sans-serif";
export const primaryFontFamily = "'Roboto', sans-serif";

export * from '@repo/ui/src/styles/variables';

export const speckleBackgroundUrl = 'https://traegergrills.a.bigcontent.io/v1/static/speckle-bg';
